import React from "react";
import { FC } from "react";
import { DataImportSchema } from "../../../../graphql/__generated_types__/DataImportSchema";
import { DataSchemaModal } from "./data-schema-modal";
import { sentenceCase } from "change-case";

export type DataSchemaDisplayModalContainerProps = {
  importTypeName: string;
  schema: DataImportSchema | undefined;
  handleClose: () => void;
};

export const DataSchemaModalContainer: FC<DataSchemaDisplayModalContainerProps> = ({
  importTypeName,
  schema,
  handleClose,
}) => {
  return schema ? (
    <DataSchemaModal
      handleClose={handleClose}
      schemaInformation={schema}
      title={sentenceCase(importTypeName)}
    ></DataSchemaModal>
  ) : null;
};
